import { type ConfirmModalProps, modals } from "@mantine/modals"
import { useTranslation } from "react-i18next"
import { AppTitle } from "@/components/utils"

interface IProps extends ConfirmModalProps {
  title?: string
}

export function useConfirm({ title, labels, ...props }: IProps = {}) {
  const { t } = useTranslation()
  return () =>
    new Promise<boolean>((resolve) =>
      modals.openConfirmModal({
        title: <AppTitle>{title || t("Are you sure?")}</AppTitle>,
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
        labels: {
          cancel: labels?.cancel || t("Cancel"),
          confirm: labels?.confirm || t("Confirm"),
        },
        ...props,
      }),
    )
}
